import React from 'react';
import Form from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/Form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { setPasswordRecoveryStep } from 'store/credentials/actions';
import { CHOOSE_METHODS_RECOVERY_PASS } from 'containers/PasswordRecoveryPages/constants';
import Header from 'containers/PasswordRecoveryPages/Header';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/messages';
import { translate } from 'helpers/intl';
import {
  getIsLoadingQuestionSelector,
  getQuestionSecretSelector,
  getErrorMessageSelector,
} from 'store/credentials/selectors';

export type QuestionSecret = {
  label: string;
  value: string;
};

const QuestionSecretForgotPassword = ({
  setPasswordRecoveryStep,
  onSubmitStep,
  isLoading,
  questionSecret,
  errorMessage,
  ...otherProps
}: {
  setPasswordRecoveryStep: Function;
  onSubmitStep: Function;
  isLoading: Boolean;
  intl: IntlShape;
  questionSecret: QuestionSecret[];
  errorMessage: string;
}) => {
  return (
    <React.Fragment>
      <Header
        title={translate(messages.formTitle, otherProps)}
        subTitle={translate(messages.formSubTitle, otherProps)}
      />
      <Form
        onSubmitStep={onSubmitStep}
        proceedDifferently={() =>
          setPasswordRecoveryStep(CHOOSE_METHODS_RECOVERY_PASS)
        }
        isLoading={isLoading}
        questionSecret={questionSecret}
        errorMessage={errorMessage}
      />
    </React.Fragment>
  );
};
const mapDispatchToProps = {
  setPasswordRecoveryStep,
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    questionSecret: QuestionSecret[];
    isLoadingQuestion: boolean;
    errorMessage: string;
  }
>({
  questionSecret: getQuestionSecretSelector,
  isLoadingQuestion: getIsLoadingQuestionSelector,
  errorMessage: getErrorMessageSelector,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(QuestionSecretForgotPassword));

export { QuestionSecretForgotPassword };
